<template>
	<!-- <Index></Index> -->
	<Drag></Drag>
</template>

<script>
	import Index from './components/index.vue'
	import Drag from './components/drag.vue'
	
	export default {
		name: 'app',
		components: {
			Index,
			Drag
		}
	}
</script>

<style>

</style>
